/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-unused-vars */
export enum PROPERTY_TYPE {
  HOUSE = 'HOUSE',
  APARTMENT = 'APARTMENT',
  TOWN_HOUSE_VILLA = 'TOWN_HOUSE_VILLA',
}
